import _ from "lodash";
import ImportController from "../controllers/ImportController";

window.handleFiles = (files, options) => {
  /**
   * @type {ImportController}
   */
  const controller = ImportController.getInstance();

  if (options && options.collectionId) {
    return controller.createOrUpdateCollectionUploadOperation([...files], options);
  }

  if (window.gs.showUploadingsModal) {
    _.each(files, file => window.gs.uploadings.push(controller.createUploading(file)));
    window.render();
  } else {
    if (_.every(window.gs.uploadings, uploading => uploading.status === 'FINISHED')) {
      window.gs.uploadings = _.map(files, file => controller.createUploading(file));
      if (!window.gs.addAssetsForm) {
        window.gs.showUploadingsModal = true;
      }
      window.render();
    } else {
      _.each(files, file => window.gs.uploadings.push(controller.createUploading(file)));
      if (!window.gs.addAssetsForm) {
        window.gs.showUploadingsModal = true;
      }
      window.render();
    }
  }

  return controller.watchUploadings();
};
